import { Drawer, CircularProgress, Box } from "@mui/material";
import Character, { CharacterType } from "./Character";

export interface CharacterDrawerProps {
    open: boolean;
    onClose: () => void;
    character: CharacterType | null;
    isLoading: boolean;
}

export default function CharacterDrawer({
    open,
    onClose,
    character,
    isLoading,
}: CharacterDrawerProps) {
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ height: "calc(100% - 64px)", overflowY: "auto", mt: 8, minWidth: 300, p: 2 }}>
                {isLoading ? <CircularProgress /> : <Character character={character!} />}
            </Box>
        </Drawer>
    );
}
